exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".mrt-10[data-v-e4f7e6b0]{margin-top:10px}.badge--pending[data-v-e4f7e6b0]{background-color:red}.pdfobject-container[data-v-e4f7e6b0]{height:75rem;border:1rem solid rgba(0,0,0,.1)}", "", {"version":3,"sources":["/home/circleci/phdva/ui/src/views/admin/order/ListErrors.vue"],"names":[],"mappings":"AACA,yBACE,eAAiB,CAClB,AACD,iCACE,oBAA0B,CAC3B,AACD,sCAAwC,aAAc,AAAC,gCAAkC,CACxF","file":"ListErrors.vue","sourcesContent":["\n.mrt-10[data-v-e4f7e6b0] {\n  margin-top: 10px;\n}\n.badge--pending[data-v-e4f7e6b0] {\n  background-color: #FF0000;\n}\n.pdfobject-container[data-v-e4f7e6b0] { height: 75rem; border: 1rem solid rgba(0,0,0,.1);\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e4f7e6b0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=3!./src/views/admin/order/ListErrors.vue
// module id = 1923
// module chunks = 0